<template>
  <div id="root">
    <template v-if="isCompetitionFetched && !isStudioBlocked">
      <RouterView />
    </template>
    <LoadingModal style="display: block" class="modal" />
    <Modals />
  </div>
</template>

<style src="./blocky/css/blocks.sass" lang="sass"></style>
<style src="./blocky/css/colors.sass" lang="sass"></style>

<script>
import { mapGetters } from 'vuex';

import {
  CloseLoadingModalEvent,
  StudioEventRedirectModalEvent
} from '@/app-events';
import LoadingModal from '@/components/modals/LoadingModal.vue';
import EventBus from '@/plugin/vue-event-bus';

import Modals from './components/modals/Modals.vue';
import PageUtils from './utils/page-utils';
import scrollLock from './utils/scroll-lock';

export default {
  name: 'app',
  components: {
    LoadingModal,
    Modals
    // EventInformation
  },
  metaInfo: {
    title: 'Studio',
    titleTemplate: '%s - Codementum'
  },
  created() {
    scrollLock.enable();

    if (!this.isStudioEvent) {
      document.body.classList.remove('app-loading');
    }

    this.registerHashChangeHandler();
  },
  beforeMount() {
    EventBus.removeAll();
  },
  mounted() {
    // For initial load of the studioevent,
    // We are setting, everyone's language to English!!
    if (this.isStudioEvent) {
      let unwatch = this.$watch(
        '$store.state.CodementumUser.account.settings.language',
        () => {
          setTimeout(() => {
            this.$set(this.$i18n, 'locale', 'en');
            this.$set(this.$root.$i18n, 'locale', 'en');
            unwatch();
          }, 10);
        }
      );
    }

    // listen events
    EventBus.listen(CloseLoadingModalEvent, this.closeLoadingModal);
  },
  computed: {
    ...mapGetters('CodementumUser', [
      'isDeveloper',
      'isManager',
      'isStaff',
      'isAdmin'
    ]),
    ...mapGetters('competition', ['competition', 'isCompetitionFetched']),
    ...mapGetters([
      'isStudioBlocked',
      'isPrivateDistributor',
      'distributorCompanyCode',
      'isStudioEvent'
    ]),
    canSee() {
      return (
        !this.isProduction &&
        (this.isDeveloper || this.isManager || this.isStaff || this.isAdmin)
      );
    },
    isProduction() {
      return this.$store.getters['CodementumUrl/buildMode'] === 'production';
    }
  },
  methods: {
    registerHashChangeHandler() {
      window.$onHashChangeHandler = function () {
        window.location.reload();
      };
      window.addHashChangeHandler = function () {
        if (window.$hasHashChangeHandler !== true) {
          window.addEventListener('hashchange', window.$onHashChangeHandler);
          window.$hasHashChangeHandler = true;
        }
      };
      window.removeHashChangeHandler = function () {
        window.removeEventListener('hashchange', window.$onHashChangeHandler);
        window.$hasHashChangeHandler = false;
      };
      window.addHashChangeHandler();
    },
    closeLoadingModal() {
      // Remove loading state
      document.body.classList.remove('app-loading');

      let loadingModal = document.querySelector('.loading-modal');
      let container = loadingModal.querySelector('.modal-container');
      if (container) {
        container.remove();
      }
      loadingModal.classList.add('fade-out');
    }
  },
  watch: {
    '$store.state.CodementumUser.account.uuid'() {
      if (this.$store.state.lastPageIndex === null) {
        this.$store.dispatch(
          'getLastPage',
          this.$store.state.CodementumUser.account.uuid
        );
      }

      this.$store
        .dispatch('competition/fetchCurrentCompetition')
        .then(() => {
          let redirectUser = false;
          if (this.isStudioEvent) {
            if (!this.competition.isLive) {
              redirectUser = true;
            } else {
              if (this.competition.options.isTesting) {
                const userGivenPassword = btoa(
                  String(window.prompt('Provide the testing password'))
                );
                redirectUser =
                  userGivenPassword !== this.competition.options.password;
              }

              if (this.competition.distributorCompanyCode !== 'CM') {
                if (
                  this.distributorCompanyCode !==
                  this.competition.distributorCompanyCode
                ) {
                  return (window.location =
                    this.$panelUrl + 'account/profile/info');
                }
              }
            }
          } else {
            // Only works when we are not in studioevent URL's
            if (
              this.competition.isLive &&
              !this.competition.options.isTesting &&
              this.isPrivateDistributor &&
              this.distributorCompanyCode ===
                this.competition.distributorCompanyCode
            ) {
              EventBus.publish(new StudioEventRedirectModalEvent());
              this.$store.commit('setIsStudioBlocked', true);
              return;
            }
          }

          if (redirectUser) {
            if (this.competition.isLive && this.competition.exitRedirectUrl) {
              return (window.location = this.competition.exitRedirectUrl);
            }

            return (window.location = this.$panelUrl + 'account/profile/info');
          }

          this.$store.commit('competition/setIsCompetitionFetched', true);
          document.body.classList.remove('app-loading');
        })
        .catch(() => {
          console.log('Seems like there is not a live competition right now.');
        });
    },
    '$store.state.CodementumUser.edLevel'() {
      const isPrimary = PageUtils.isPrimary();
      const isSchoolPrimary =
        this.$store.getters['CodementumUser/isEdLevelPrimarySchool'];

      if (!isPrimary && isSchoolPrimary) {
        if (PageUtils.isLocalhost()) {
          alert('Bu kullanicinin normalde studio dan cozmesi gerekiyor!');
        } else {
          const change = location.origin.split('.')[0];
          location.href = location.origin.replace(
            change,
            change.replace('2', '')
          );
        }
      }

      if (isPrimary && !isSchoolPrimary) {
        if (PageUtils.isLocalhost()) {
          alert('Bu kullanicinin normalde studio2 dan cozmesi gerekiyor!');
        } else {
          const change = location.origin.split('.')[0];
          location.href = location.origin.replace(change, change + '2');
        }
      }
    }
  }
};
</script>
